/** Indian PAN: 5 letters + 4 digits + 1 letter (e.g. ABCDE1234F) */
const PAN_PATTERN = /^[A-Z]{5}\d{4}[A-Z]$/;

/** Indian GSTIN: 15-character structure */
const GSTIN_PATTERN =
  /^\d{2}[A-Z]{5}\d{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;

export function normalizePan(input: string): string {
  return input.replace(/\s/g, '').toUpperCase();
}

/** Empty is allowed (optional field). */
export function validateIndianPan(raw: string): string | null {
  const s = normalizePan(raw);
  if (!s) {
    return null;
  }
  if (!PAN_PATTERN.test(s)) {
    return 'Enter a valid PAN (format: ABCDE1234F).';
  }
  return null;
}

export function normalizeGstin(input: string): string {
  return input.replace(/\s/g, '').toUpperCase();
}

/** Empty is allowed (optional field). */
export function validateIndianGstin(raw: string): string | null {
  const s = normalizeGstin(raw);
  if (!s) {
    return null;
  }
  if (s.length !== 15) {
    return 'GST number must be exactly 15 characters.';
  }
  if (!GSTIN_PATTERN.test(s)) {
    return 'Enter a valid GST number (GSTIN).';
  }
  return null;
}
